<template>
    <v-btn
        :id="gtmId"
        :outlined="isOutlined"
        text
        block
        class="text-none"
        :class="{'cookie-disclaimer__cta': thickBorder}"
        :style="buttonStyles"
        @click.prevent="clickAction"
    >
        {{ text }}
    </v-btn>
</template>

<script>
    export default {
        name: 'DisclaimerButton',
        props: {
            'gtmId': {
                type: String,
                required: true
            },
            'text': {
                type: String,
                required: true
            },
            'backgroundColor': {
                type: String,
                require: true
            },
            'textColor': {
                type: String,
                require: true
            },
            'thickBorder': {
                type: Boolean,
                default: false
            },
            'isOutlined': {
                type: Boolean,
                default: true
            }
        },
        computed: {
            buttonStyles() {
                return {
                    'background-color': this.backgroundColor,
                    'color': this.textColor,
                    'border-radius': '8px',
                    'padding': 'unset'
                };
            }
        },
        methods: {
            clickAction() {
                this.$emit('click-action');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/components/DisclaimerButton.vue